import "core-js/modules/es.object.to-string";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/Users/viniciuskneves/workspace/own/vue-3-suspense/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";

function asyncSetTimeout(timeout) {
  return new Promise(function (resolve) {
    return setTimeout(resolve, timeout);
  });
}

export default {
  name: "Suspense route",
  setup: function setup() {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return asyncSetTimeout(3000);

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  }
};